import React, { useCallback, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import Pagination from "../Pagination";

const AlbumSlider = ({ photo_urls }) => {
  const [photoIndex, setPhotoIndex] = useState(0);

  const handleChangeIndex = useCallback(
    (i) => {
      setPhotoIndex(i);
    },
    [setPhotoIndex]
  );

  return (
    <React.Fragment>
      <SwipeableViews
        enableMouseEvents
        index={photoIndex}
        onChangeIndex={(i) => handleChangeIndex(i)}
      >
        {photo_urls.length
          ? photo_urls.map((url, idx) => (
              <figure key={idx} className="adjust-box adjust-box-3x2 mb-0">
                <img
                  data-src={url}
                  alt={"アルバムの画像"}
                  className="adjust-box-inner lazyload w-100 object-fit-cover"
                  // onError={onError()}
                />
              </figure>
            ))
          : ""}
      </SwipeableViews>
      <Pagination
        dots={photo_urls.length > 1 ? photo_urls.length : 0}
        index={photoIndex}
        onChangeIndex={(i) => handleChangeIndex(i)}
      />
    </React.Fragment>
  );
};

export default AlbumSlider;
